import { Link } from "react-router-dom"
import { ArrowRight, LucideIcon } from "lucide-react"

interface CTABoxProps {
  icon: LucideIcon
  heading: string
  body: string
  ctaLabel: string
  ctaHref: string
}

export default function CTABox({ icon: Icon, heading, body, ctaLabel, ctaHref }: CTABoxProps) {
  return (
    <div className="mt-16 bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 sm:p-10 text-white shadow-xl relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-primary/20 blur-3xl rounded-full opacity-50" />
      
      <div className="relative z-10 flex flex-col sm:flex-row gap-8 items-center justify-between">
        <div className="flex-1 text-center sm:text-left">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-xl mb-4 backdrop-blur-sm">
            <Icon className="w-6 h-6 text-primary-200" />
          </div>
          <h3 className="text-2xl font-bold mb-2">{heading}</h3>
          <p className="text-slate-300 text-lg">{body}</p>
        </div>
        
        <div className="w-full sm:w-auto flex-shrink-0">
          <Link
            to={ctaHref}
            className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-base font-semibold text-slate-900 bg-white rounded-xl hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900 focus:ring-white transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            {ctaLabel}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  )
}
